export default "__VITE_ASSET__eb14aae4__"